export const translations = {
  HIDE: {
    sv: 'Stäng meddelande',
    en: 'Dismiss message',
    da: 'Afvis besked',
    fi: 'Hylkää viesti',
    no: 'Avvis meldingen',
  },
};
